import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useLoader} from "./LoaderContext";

const RouteChangeHandler = () => {
  const location = useLocation();
  const {showLoader} = useLoader();

  useEffect(() => {
    showLoader();
  }, [location.pathname]);

  return null;
};

export default RouteChangeHandler;
